module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Electric/Outlet-390ebf342360af1ba79e4c39f25db34e.svg";